module.exports.main = `
  INSERT INTO fin.deposit (
       origin, company, txn_id, txn_date,
       account_id, amount, currency, private_note
  )
  SELECT origin
       , company
       , txn_id
       , txn_date
       , (data->'DepositToAccountRef'->>'value')::INTEGER as account_id
       , (data->>'TotalAmt')::NUMERIC as amount
       , (data->'CurrencyRef'->>'value')::fin.currency_type as currency
       , (data->>'PrivateNote') as private_note
  FROM raw
`
module.exports.line = `
  INSERT INTO fin.deposit_line (
      origin, company, txn_id, line_num,
      account_id, customer_id, amount, description
  )
  SELECT origin
       , company
       , txn_id
       , line_num
       , (line->'DepositLineDetail'->'AccountRef'->>'value')::INTEGER
         as account_id
       , (line->'DepositLineDetail'->'Entity'->>'value'):: INTEGER
         as customer_id
       , (line->>'Amount')::NUMERIC as amount
       , (line->>'Description') as description
  FROM raw
  INNER JOIN jsonb_array_elements(data->'Line')
             WITH ORDINALITY AS l(line, line_num) ON TRUE
  WHERE line->>'DetailType' = 'DepositLineDetail'
    AND line->'Amount' IS NOT NULL
`

module.exports.rawCustomerIds = `
  SELECT origin
       , company
       , (line->'DepositLineDetail'->'Entity'->>'value'):: INTEGER
         as customer_id
  FROM raw
  INNER JOIN jsonb_array_elements(data->'Line') AS line ON TRUE
  WHERE line->>'DetailType' = 'DepositLineDetail'
    AND line->'Amount' IS NOT NULL
`

module.exports.rawAccountIds = `
  SELECT origin
       , company
       , (line->'DepositLineDetail'->'AccountRef'->>'value'):: INTEGER
         as customer_id
  FROM raw
  INNER JOIN jsonb_array_elements(data->'Line') AS line ON TRUE
  WHERE line->>'DetailType' = 'DepositLineDetail'
    AND line->'Amount' IS NOT NULL
`
